module.exports = "/assets/data/2ea092f433f4e99cb573275b497e5d85-NE68.data.json";